'use client';

import * as React from 'react';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAuthData } from '@/hooks/getAuthData';
import { useAuth } from '@/contexts/AuthContext';

/** Top-right gear for admins: current BU setup (name + logo), or list if no current BU. */
export function AdminBusinessUnitSetupButton() {
  const { roles } = useAuthData();
  const { user } = useAuth();
  const isAdmin = roles.some(
    (r) => r.name === 'Admin' || r.name === 'SystemAdmin',
  );
  if (!isAdmin) return null;
  const code = user?.currentBusinessUnit?.code;
  const to = code
    ? `/app/business-units/${code}/setup`
    : '/app/business-units';
  return (
    <Tooltip title={code ? 'Business unit setup' : 'Business units'}>
      <IconButton
        component={Link}
        to={to}
        size="small"
        aria-label="Business unit setup"
        sx={{ color: 'text.secondary' }}
      >
        <SettingsIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
